import common from './common.js'
import store from '../store/modules/common.js'
import OSS from 'ali-oss'
import http from './http.js'
import i18n from '../src/lang' //语言包
import wx from 'weixin-js-sdk';
import {
	Toast
} from 'vant';

let client = common.client

export default {
	// 多位数字每隔三位加一个逗号
	add_comma_toThousands(num) {
		var result = '';
		if (!(num || num == 0)) {
			return result
		}
		num = (num || 0).toString();
		while (num.length > 3) {
			result = ',' + num.slice(-3) + result;
			num = num.slice(0, num.length - 3);
		}
		if (num) {
			result = num + result;
		}
		return result;
	},
	setcookie(name, data) {
		console.log({
			action: "set",
			key: name,
			val: data
		})
		if (typeof WebViewJavascriptBridge != "undefined" && !!WebViewJavascriptBridge) {
			window.WebViewJavascriptBridge.callHandler(
				'localStorage', {
					action: "set",
					key: name,
					val: data
				},
				function(responseData) {}
			);
		}
	},
	delcookie(name) {
		if (typeof WebViewJavascriptBridge != "undefined" && !!WebViewJavascriptBridge) {
			window.WebViewJavascriptBridge.callHandler(
				'localStorage', {
					action: "del",
					key: name
				},
				function(responseData) {}
			);
		}
	},
	getParamsStr(list, type) {
		let str = "";
		if (list && list.length) {
			list.forEach(i => {
				if (i.name) {
					str = str + `${i.name}${i.value ? `:${i.value}` : ''}`
				}
			})
			return str
		} else {
			return "";
		}
	},
	comparisonTime(name) {
		if (!localStorage.getItem(name)) {
			return false;
		}
		let name_ = JSON.parse(localStorage.getItem(name));
		let s2;
		if (typeof name_ == "object") {
			s2 = name_.guoqiData;
		} else {
			s2 = name_
		}
		let s1 = (new Date()).getTime();

		if (s1 < s2) {
			return true
		} else {
			localStorage.removeItem(name);
			return false
		}
	},
	unique(arr) {
		var newArr = [];
		for (var i = 0; i < arr.length; i++) {
			if (newArr.indexOf(arr[i]) == -1) {
				newArr.push(arr[i])
			}
		}
		return newArr;
	},
	getRemainderTime(startTime, time, name) {
		if (!localStorage.getItem(name)) {
			return false;
		}
		var s1 = startTime,
			s2 = (new Date()).getTime(),
			runTime = parseInt((s2 - s1) / 1000);
		var year = Math.floor(runTime / 86400 / 365);
		runTime = runTime % (86400 * 365);
		var month = Math.floor(runTime / 86400 / 30);
		runTime = runTime % (86400 * 30);
		var day = Math.floor(runTime / 86400);
		runTime = runTime % 86400;
		var hour = Math.floor(runTime / 3600);
		runTime = runTime % 3600;
		var minute = Math.floor(runTime / 60);
		runTime = runTime % 60;
		var second = runTime;
		let flag = false;
		if (time == 15) {
			if (year == 0 && month == 0 && day == 0 && hour == 0 && time < 15) {
				flag = true
			} else {
				localStorage.removeItem(name);
			}
		}
		if (time == 60) {
			if (year == 0 && month == 0 && day == 0 && hour < 1 && time < 60) {
				flag = true
			} else {
				localStorage.removeItem(name);
			}
		}
		return flag;
	},
	removeHistory() {
		let historyArr = (localStorage.getItem("StudentmbHistoryArr") && JSON.parse(localStorage.getItem(
			"StudentmbHistoryArr"))) || [];
		historyArr.pop();
		localStorage.setItem("StudentmbHistoryArr", JSON.stringify(historyArr));
	},

	goback(this_) {
		console.log('返回')
		let historyArr = (localStorage.getItem("StudentmbHistoryArr") && JSON.parse(localStorage.getItem(
			"StudentmbHistoryArr"))) || [];
		let historyArr_ = (sessionStorage.getItem("historyArr") && JSON.parse(sessionStorage.getItem("historyArr"))) || [];
		if (localStorage.getItem("liveMyCollect")) {
			let lastArr = historyArr_[historyArr_.length - 1]
			console.log('返回', lastArr)
			localStorage.removeItem("liveMyCollect");
			this.removeHistory();
			if (lastArr.length == 0) {
				window.location.href = `${this_.WITSBOX_ENV_PARAM.domain}/shop-mb/#/home/index`;
			} else {
				window.location.href = `${this_.WITSBOX_ENV_PARAM.domain}/shop-mb/#${lastArr.value}`;
			}

		} else {
			if (historyArr.length > 1) {
				let fullPath = historyArr[historyArr.length - 2].value;
				this_.$router.replace({
					path: fullPath
				});
			} else {
				this_.$router.replace({
					path: "/user/login"
				});
			}
		}

	},
	StudyGoback(this_, tbIndex, cur) {
		let historyArr = (localStorage.getItem("StudentmbHistoryArr") && JSON.parse(localStorage.getItem(
			"StudentmbHistoryArr"))) || [];
		for (var i = 0; i < historyArr.length; i++) {
			if (historyArr[i].key == this_.$route.path) {
				historyArr[i].value = this_.$route.path + "?curSalonTab=" + tbIndex + "&tbIndex=" + cur;
			}
		}
		localStorage.setItem("StudentmbHistoryArr", JSON.stringify(historyArr));
	},
	ModifiesGoback1(this_, tbIndex, id) {
		let historyArr = (localStorage.getItem("StudentmbHistoryArr") && JSON.parse(localStorage.getItem(
			"StudentmbHistoryArr"))) || [];
		for (var i = 0; i < historyArr.length; i++) {
			if (historyArr[i].key == this_.$route.path) {
				historyArr[i].value = this_.$route.path + "?id=" + id + "&tab=" + tbIndex;
			}
		}
		localStorage.setItem("StudentmbHistoryArr", JSON.stringify(historyArr));
	},
	ModifiesGoback(this_, tbIndex) {
		let historyArr = (localStorage.getItem("StudentmbHistoryArr") && JSON.parse(localStorage.getItem(
			"StudentmbHistoryArr"))) || [];
		for (var i = 0; i < historyArr.length; i++) {
			if (historyArr[i].key == this_.$route.path) {
				historyArr[i].value = this_.$route.path + "?tab=" + tbIndex;
			}
		}
		localStorage.setItem("StudentmbHistoryArr", JSON.stringify(historyArr));
	},
	// 通过 ossKey 得到链接
	getOssFileUrl(ossKey) {
		if (!ossKey) {
			console.log('无效的参数')
			return
		}
		let url = common.baseUrl + "/common/ossFileUrl?key=" + ossKey
		// let url = client.signatureUrl(ossKey, { expires: 3600 });
		return url
	},
	// 通过 ossKey 得到链接
	getOssFileUrlA(ossKey) {
		if (!ossKey) {
			console.log('无效的参数')
			return
		}
		let url = common.baseUrl + "/common/ossFileUrlA?key=" + ossKey
		return url
	},
	// 获取带签名的全地址url
	getOssFileSignatureUrl(ossKey) {
		client = new OSS({
			region: common.ossObject.region,
			accessKeyId: common.ossObject.accessKeyId,
			accessKeySecret: common.ossObject.accessKeySecret,
			bucket: common.ossObject.bucket
		});
		if (!ossKey) {
			console.log('无效的参数')
			return
		}
		let url = client.signatureUrl(ossKey, {
			expires: 3600
		});
		return url
	},
	// 直接上传文件到阿里
	async putOssObject(ossFile, localFile) {
		client = new OSS({
			region: common.ossObject.region,
			accessKeyId: common.ossObject.accessKeyId,
			accessKeySecret: common.ossObject.accessKeySecret,
			bucket: common.ossObject.bucket
		});
		let result = client.multipartUpload(ossFile, localFile, {
			progress: async function(p, checkpoint) {
				let percent = Math.round(Number(p) * 100)
				console.log(percent)
			}
		})
		return result
	},
	async multipartUpload(ossFile, localFile) {
		client = new OSS({
			region: common.ossObject.region,
			accessKeyId: common.ossObject.accessKeyId,
			accessKeySecret: common.ossObject.accessKeySecret,
			bucket: common.ossObject.bucket
		});
		try {
			await client.multipartUpload(ossFile, localFile, {
				progress: async function(p, checkpoint) {
					tempCheckpoint = checkpoint;
				}
			});
		} catch (e) {
			console.log(e);
		}
	},
	/* 生成随机位数的uid,此处用于存入阿里的uid */
	getUUid() {
		let str = new Date().getTime(),
			pos = '',
			arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e',
				'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u',
				'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',
				'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
			];
		for (var i = 0; i < 11; i++) {
			pos = Math.round(Math.random() * (arr.length - 1));
			str += arr[pos];
		}
		return str;
	},
	// 根据月份获取季度
	getQuarterByMonth(month) {
		let firstQuarter = 3 / 12 // 第一季度
		let secondQuarter = 6 / 12 // 第二季度
		let thirdQuarter = 9 / 12 // 第三季度
		let fourthQuarter = 12 / 12 // 第四季度
		let result = ''
		if (month / 12 <= firstQuarter) {
			result = 1
		} else if (month / 12 > firstQuarter && month / 12 <= secondQuarter) {
			result = 2
		} else if (month / 12 > secondQuarter && month / 12 <= thirdQuarter) {
			result = 3
		} else if (month / 12 > thirdQuarter && month / 12 <= fourthQuarter) {
			result = 4
		}
		return result
	},
	$CheckIsNullOrEmpty(value) {
		//正则表达式用于判斷字符串是否全部由空格或换行符组成
		let reg = /^\s*$/
		//有值 返回true
		//无值 返回false
		return (value !== null && value !== undefined && !reg.test(value));
	},
	// 获取去除零的时间
	getRemoveZeroTime(date, format = "yyyy.mm.dd H:i:s") {
		if (!date) {
			return "";
		}
		if (date.indexOf(".0") > -1) {
			// 判断是否包含指定字符.0
			date = date.replace(".0", "");
		}
		return this.formatDate(date, format);
	},
	showByRoles(inputRoles) {
		if (!(inputRoles && inputRoles.length)) {
			return
		}
		let roles = localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')) || []
		if (inputRoles.length) {
			// 是否有权限
			let flag = false
			for (let i = 0; i < inputRoles.length; i++) {
				if (roles.indexOf(inputRoles[i]) > -1) {
					flag = true
					break
				}
			}
			return flag
		}
	},
	isType(val, type) {
		return Object.prototype.toString.call(val) === `[object ${type}]`
	},
	/**
	 * null转化为''
	 */
	nullToQuote(obj) {
		let objIsArr = this.isType(obj, 'Array')
		// 是数组 递归里面的 里面的是对象或者数组 递归 不是 就改值
		if (objIsArr) {
			obj.forEach(i => this.isType(i, 'Object') || this.isType(i, 'Array') ? this.nullToQuote(i) : i == null ? '' : i)
		} else {
			// 对象里的属性 是数组或者对象 就继续递归
			for (let key in obj) {
				if (this.isType(obj[key], 'Object') || this.isType(obj[key], 'Array')) {
					this.nullToQuote(obj[key])
				} else {
					obj[key] = obj[key] == null ? "" : obj[key];
				}
			}
		}
		return obj;
	},
	// 这里的date只能传字符串，如果不是字符串先转义成时间戳
	formatDate(date, format = "yyyy.mm.dd H:i:s", isCompletion = true) {
		if (!date) {
			return "";
		}

		if (typeof date == "string") {
			date = date.replace(/\-/g, "/");
		}
		date = new Date(date);
		// 将接口返的时间格式转为 y-m-d H:i:s
		var y = date.getFullYear();
		var m = date.getMonth() + 1;
		if (isCompletion) m = m < 10 ? "0" + m : m;
		var d = date.getDate();
		if (isCompletion) d = d < 10 ? "0" + d : d;
		var h = date.getHours();
		h = h < 10 ? "0" + h : h;
		var minute = date.getMinutes();
		minute = minute < 10 ? "0" + minute : minute;
		var second = date.getSeconds();
		second = second < 10 ? "0" + second : second;
		var result;
		switch (format) {
			case "H:i":
				result = h + ":" + minute;
				break;
			case "H:i:s":
				result = h + ":" + minute + ":" + second;
				break;
			case "yyyy-mm":
				result = y + "-" + m;
				break;
			case "yyyy-mm-dd":
				result = y + "-" + m + "-" + d;
				break;
			case "yyyy-mm-dd H:i":
				result = y + "-" + m + "-" + d + " " + h + ":" + minute;
				break;
			case "yyyy/mm/dd":
				result = y + "/" + m + "/" + d;
				break;
			case "yyyy/mm":
				result = y + "/" + m;
				break;
			case "yyyy年mm月dd日":
				result = y + "年" + m + "月" + d + "日";
				break;
			case "yyyy年mm月dd日 H:i:s":
				result =
					y +
					"年" +
					m +
					"月" +
					d +
					"日" +
					" " +
					h +
					":" +
					minute +
					":" +
					second;
				break;
			case "yyyy年mm月dd日 H:i":
				result =
					y +
					"年" +
					m +
					"月" +
					d +
					"日" +
					" " +
					h +
					":" +
					minute;
				break;
			case "mm月dd日 H:i":
				result =
					m +
					"月" +
					d +
					"日" +
					" " +
					h +
					":" +
					minute;
				break;
			case "yyyy/mm/dd H:i:s":
				result = y + "/" + m + "/" + d + " " + h + ":" + minute + ":" + second;
				break;
			case "yyyy-mm-dd H:i:s":
				result = y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
				break;
			case "yyyy/mm/dd H:i":
				result = y + "/" + m + "/" + d + " " + h + ":" + minute;
				break;
			case "yyyy.mm.dd":
				result = y + "." + m + "." + d;
				break;

			case "yyyy.mm.dd H:i":
				result = y + "." + m + "." + d + " " + h + ":" + minute;
				break;
			case "yyyy.mm.dd":
				result = y + "." + m + "." + d;
				break;
			case "mm.dd H:i":
				result = m + "." + d + " " + h + ":" + minute;
				break;
			case "mm.dd":
				result = m + "." + d;
				break;
			case "H:i":
				result = h + ":" + minute;
				break;
			case "H":
				result = h;
				break;
			default:
				result = y + "." + m + "." + d + " " + h + ":" + minute + ":" + second;
				break;
		}
		return result;
	},
	getNowFormatDate(format = "yyyy-mm-dd hh:mm:ss") {
		//获取当前时间 格式为"yyyy-mm-dd hh:mm:ss"
		let date = new Date();
		let month = date.getMonth() + 1;
		let strDate = date.getDate();
		let hour = date.getHours();
		let min = date.getMinutes();
		let sec = date.getSeconds();
		if (month >= 1 && month <= 9) {
			month = "0" + month;
		}
		if (strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
		}
		if (hour >= 0 && hour <= 9) {
			hour = "0" + hour;
		}
		if (min >= 0 && min <= 9) {
			min = "0" + min;
		}
		if (sec >= 0 && sec <= 9) {
			sec = "0" + sec;
		}
		let seperator1, seperator2, currentdate;
		switch (format) {
			case "yyyy/mm/dd":
				seperator1 = "/";
				currentdate =
					date.getFullYear() + seperator1 + month + seperator1 + strDate;
				break;
			case "yyyy-mm-dd":
				seperator1 = "-";
				currentdate =
					date.getFullYear() + seperator1 + month + seperator1 + strDate;
				break;
			case "yyyy-mm":
				seperator1 = "-";
				currentdate = date.getFullYear() + seperator1 + month;
				break;
			case "yyyy-mm-dd hh:mm":
				seperator1 = "-";
				seperator2 = ":";
				currentdate =
					date.getFullYear() +
					seperator1 +
					month +
					seperator1 +
					strDate +
					" " +
					hour +
					seperator2 +
					min
				break;
			case "yyyy/mm/dd hh:mm:ss":
				seperator1 = "/";
				seperator2 = ":";
				currentdate =
					date.getFullYear() +
					seperator1 +
					month +
					seperator1 +
					strDate +
					" " +
					hour +
					seperator2 +
					min +
					seperator2 +
					sec;
				break;
			default:
				seperator1 = "-";
				seperator2 = ":";
				currentdate =
					date.getFullYear() +
					seperator1 +
					month +
					seperator1 +
					strDate +
					" " +
					hour +
					seperator2 +
					min +
					seperator2 +
					sec;
				break;
		}
		return currentdate;
	},

	getTimeStamp(date) {
		//将接口返的时间格式转为时间戳
		// return Date.parse(new Date(date))||Date.parse(new Date(date.replace(/-/g,'/')))
		let time = this.formatDate(new Date(date));
		time = Math.round(new Date(time.replace(/-/g, "/")).getTime() / 1000);
		return time;
	},
	// date为y-m-d H:i:s
	getTimeStampJR(date) {
		return Date.parse(new Date(date)) || Date.parse(new Date(date.replace(/-/g, '/')))
	},

	contains(arr, obj) {
		// 当前值 是否在指定数组内
		var i = arr.length;
		while (i--) {
			if (arr[i] === obj) {
				return true;
			}
		}
		return false;
	},
	isEmojiCharacter(substring) {
		for (var i = 0; i < substring.length; i++) {
			var hs = substring.charCodeAt(i);
			if (0xd800 <= hs && hs <= 0xdbff) {
				if (substring.length > 1) {
					var ls = substring.charCodeAt(i + 1);
					var uc = (hs - 0xd800) * 0x400 + (ls - 0xdc00) + 0x10000;
					if (0x1d000 <= uc && uc <= 0x1f77f) {
						return true;
					}
				}
			} else if (substring.length > 1) {
				var ls = substring.charCodeAt(i + 1);
				if (ls == 0x20e3) {
					return true;
				}
			} else {
				if (0x2100 <= hs && hs <= 0x27ff) {
					return true;
				} else if (0x2b05 <= hs && hs <= 0x2b07) {
					return true;
				} else if (0x2934 <= hs && hs <= 0x2935) {
					return true;
				} else if (0x3297 <= hs && hs <= 0x3299) {
					return true;
				} else if (
					hs == 0xa9 ||
					hs == 0xae ||
					hs == 0x303d ||
					hs == 0x3030 ||
					hs == 0x2b55 ||
					hs == 0x2b1c ||
					hs == 0x2b1b ||
					hs == 0x2b50
				) {
					return true;
				}
			}
		}
	},

	// 时间戳转换为 2018.11.12  周三 18:00-18:25 || 2018.11.12  周三 18:00
	// 今天 10:00-10:15 || 明天 10:00-10:15 || 2018.12.10  10:00-10:15 跨天只显示开始时间 
	getFormatTime(start, end, isNewFormat = false, canCrossDay = false, isShowWeek = false, isShowTime = true) {
		if (!start) return "";
		let startTime = {
			year: new Date(Number(start)).getFullYear(),
			month: this.fixedData(new Date(Number(start)).getMonth() + 1),
			day: this.fixedData(new Date(Number(start)).getDate()),
			hour: this.fixedData(new Date(Number(start)).getHours()),
			minute: this.fixedData(new Date(Number(start)).getMinutes())
		};
		let endTime = "";
		let week = this.getWeek(new Date(Number(start)));
		let result = this.showDay(isNewFormat, start, startTime);
		if (!result) {
			result += startTime.year + "." + startTime.month + "." + startTime.day;
		}
		result += (isShowWeek ? " " + week : "");
		result += (isShowTime ? (" " + startTime.hour + ":" + startTime.minute) : "");
		if (end) {
			endTime = {
				year: new Date(Number(end)).getFullYear(),
				month: this.fixedData(new Date(Number(end)).getMonth() + 1),
				day: this.fixedData(new Date(Number(end)).getDate()),
				hour: this.fixedData(new Date(Number(end)).getHours()),
				minute: this.fixedData(new Date(Number(end)).getMinutes())
			};
			result += this.isSameDay(startTime, endTime) ? //时间在同一天 则不显示结束的日期只显示时间
				(isShowTime ? ("-" + endTime.hour + ":" + endTime.minute) : "") :
				canCrossDay ? //允许跨天则只显示开始时间 不管结束
				"" : ("-" + endTime.year + "." + endTime.month + "." + endTime.day +
					(isShowTime ? //不显示时分
						" " + endTime.hour + ":" + endTime.minute :
						""));
		}

		return result;
	},
	// 主要用于小班课的显示
	// 今天 10:00-10:15 || 明天 10:00-10:15 || 6月11日14:00-14:30
	getNewFormatTime(start, end, isShowWeek = false, isShowTime = true) {
		if (!start || !end) return "";
		let startTime = {
			year: new Date(Number(start)).getFullYear(),
			month: new Date(Number(start)).getMonth() + 1,
			day: new Date(Number(start)).getDate(),
			hour: this.fixedData(new Date(Number(start)).getHours()),
			minute: this.fixedData(new Date(Number(start)).getMinutes())
		};
		let week = this.getWeek(new Date(Number(start)));
		let endTime = {
			year: new Date(Number(end)).getFullYear(),
			month: new Date(Number(end)).getMonth() + 1,
			day: new Date(Number(end)).getDate(),
			hour: this.fixedData(new Date(Number(end)).getHours()),
			minute: this.fixedData(new Date(Number(end)).getMinutes())
		};
		let result = this.showDay(start, 1);
		if (!result) {
			result += this.getUnitTime(startTime, 0);
		}
		result += isShowWeek ? " " + week : "";
		result += isShowTime ? (" " + startTime.hour + ":" + startTime.minute) : "";
		result += isShowTime ? ("-" + endTime.hour + ":" + endTime.minute) : "";
		return result;
	},
	// 6月3日 || 06.03
	getUnitTime(time, showYear) {
		let yearStr = showYear ? time.year + i18n.t("study.yearUnit") : "";
		if (this.isEn()) {
			return yearStr + this.fixedData(time.month) + "." + this.fixedData(time.day);
		} else {
			return yearStr + time.month + "月" + time.day + "日";
		}
	},
	// 是否是同一天
	isSameDay(startTime, endTime) {
		return startTime.year == endTime.year && startTime.month == endTime.month && startTime.day == endTime.day;
	},
	// 今天 明天
	showDay(start, isNewFormat) {
		let res = ""
		if (isNewFormat) {
			let nowDay = new Date(),
				nowT = new Date(nowDay.getFullYear(), nowDay.getMonth(), nowDay.getDate()),
				startDay = new Date(start),
				startT = new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate()),
				dayT = parseInt((startT - nowT) / 1000 / 60 / 60 / 24);
			if (dayT == 0) {
				return '今天';
			} else if (dayT == 1) {
				return '明天';
			}
		}
		return res
	},
	// 今天 上午   下午
	showWxDay(start) {
		let nowDay = new Date(),
			nowT = new Date(nowDay.getFullYear(), nowDay.getMonth(), nowDay.getDate()),
			startDay = new Date(start),
			startT = new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate()),
			dayT = parseInt((startT - nowT) / 1000 / 60 / 60 / 24);
		if (dayT == 0) {
			let sw = this.formatDate(Number(start),"H")
			if(sw<=11){
				return '上午' + this.formatDate(start,"H:i") ;
			}else{
				return '下午' + this.formatDate(start,"H:i") ;
			}
			
		}else{
			return this.formatDate(start,"yyyy.mm.dd H:i") 
		}

		
	},
	//根据时间判断星期几
	getWeek(timedat) { //timedat参数格式：   getWeek（new Date("2017-10-27" )）
		let week;
		if (timedat.getDay() == 0) week = i18n.t("study.weekdate7");
		if (timedat.getDay() == 1) week = i18n.t("study.weekdate1");
		if (timedat.getDay() == 2) week = i18n.t("study.weekdate2");
		if (timedat.getDay() == 3) week = i18n.t("study.weekdate3");
		if (timedat.getDay() == 4) week = i18n.t("study.weekdate4");
		if (timedat.getDay() == 5) week = i18n.t("study.weekdate5");
		if (timedat.getDay() == 6) week = i18n.t("study.weekdate6");
		return week;
	},
	//根据时间判断星期几
	getWeekEn(timedat) { //timedat参数格式：   getWeek（new Date("2017-10-27" )）
		let week;
		if (timedat.getDay() == 0) week = "Sun";
		if (timedat.getDay() == 1) week = "Mon";
		if (timedat.getDay() == 2) week = "Tue";
		if (timedat.getDay() == 3) week = "Wed";
		if (timedat.getDay() == 4) week = "Thur";
		if (timedat.getDay() == 5) week = "Fri";
		if (timedat.getDay() == 6) week = "Sat";
		return week;
	},
	getShortWeek(str) {
		let week = str;
		if (str == 'Monday') week = 'Mon.';
		if (str == 'Tuesday') week = 'Tues.';
		if (str == 'Wednesday') week = 'Wed.';
		if (str == 'Thursday') week = 'Thur.';
		if (str == 'Friday') week = 'Fri.';
		if (str == 'Saturday') week = 'Sat.';
		if (str == 'Sunday') week = 'Sun.';
		return week;
	},
	getShortMonth(month) {
		let str = "";
		if (month == 1) str = 'Jan ';
		if (month == 2) str = 'Feb ';
		if (month == 3) str = 'Mar ';
		if (month == 4) str = 'Apr ';
		if (month == 5) str = 'May ';
		if (month == 6) str = 'Jun ';
		if (month == 7) str = 'Jul ';
		if (month == 8) str = 'Aug ';
		if (month == 9) str = 'Sept ';
		if (month == 10) str = 'Oct ';
		if (month == 11) str = 'Nov ';
		if (month == 12) str = 'Dec ';
		return str;
	},
	// Jun.25.2020
	getEnDate(time) {
		let m = this.getShortMonth(new Date(time).getMonth() + 1);
		let day = new Date(time).getDate();
		let year = new Date(time).getFullYear();
		return m + day + "," + year;
	},
	getMonthAndDay(date, showYear) {
		let result
		let year = new Date(Number(date)).getFullYear()
		let month = this.fixedData(new Date(Number(date)).getMonth() + 1)
		let day = this.fixedData(new Date(Number(date)).getDate())
		if (showYear) {
			result = year + "-" + month + "-" + day
		} else {
			result = month + "-" + day
		}
		return result
	},
	fixedData(time) {
		let data = time * 1
		if (data < 10) {
			data = "0" + data
		}
		return data
	},

	// 跳转下载 neo App
	openNeoApp() {
		// Toast(i18n.t("neo.pleaseLearnNEO"));
		let data = {
			action: "openapp"
		};
		this.jscallapp(data);
	},
	// 跳转下载 Dyned App
	openDynedApp() {
		// Toast(i18n.t("neo.pleaseLearnDyned"));
		let data = {
			action: "opendyned"
		};
		this.jscallapp(data);
	},
	// app 检查更新
	checkUpdate() {
		var data = {
			action: "checkupdate"
		};
		this.jscallapp(data)
	},
	// app 获取版本号
	getVersion() {
		let data = {
			action: "getversion"
		};
		this.jscallapp(data)
	},
	// app清除缓存
	clearCache() {
		let data = {
			action: "clearCache"
		};
		this.jscallapp(data)
	},
	//  调用苹果支付
	applepay(courseId) {
		let data = {
			action: "applepay",
			id: courseId
		};
		console.log(data);
		this.jscallapp(data);
	},
	// app下载图片
	downloadImg(url) {
		let data = {
			action: "downloadimage",
			url: url
		};
		this.jscallapp(data);
	},
	// app跳转登录页
	gotologin(url) {
		// let data = { action: "gotologin"};
		// this.jscallapp(data);
	},
	openxcx(path, xcxid) {
		localStorage.removeItem("studyThemeList");
		console.log('清除授权')

		// "release"  正式
		// "test"     开发
		// "preview"  体验
		let data = {
			action: "openxcx",
			appid: common.appModelId,
			path: path,
			xcxid: xcxid,
			type: "release"
		};
		this.jscallapp(data);
	},
	openjs(path, xcxid) {
		console.log(path, xcxid)
		let data = {
			action: "openxcx",
			appid: common.appJSModelId,
			path: path,
			xcxid: xcxid,
			type: "release"
		};
		this.jscallapp(data);
	},
	openZH(path, xcxid) {
		let data = {
			action: "openZH",
			appid: common.appZHModelId,
			path: path,
			xcxid: xcxid,
			type: "release"
		};
		this.jscallapp(data);
	},
	weixinshare(params) {
		// type  0:发送给好友   1：发送到朋友圈
		// url  title type 这三个内容必填
		let link = params.link || ""
		let url = common.wxStuUrl + link.substring(link.indexOf("/#/"));
		var data = {
			action: "weixinshare",
			url: url, // "https://www.baidu.com",
			title: params.title, // "测试分享的标题",
			description: (params.desc || "").replace(/<[^>]+>/g, ""), // "分享内容描述",
			type: params.contentType || "", // '0'
			imgUrl: params.imgUrl,
			rankId: params.rankId || "",
			shareUserId: (params.shareUserId || "").toString(),
			shareType: params.shareType || "", // 1转发浏览数 2转发数  3新增粉丝数
			rankType: params.rankType || "", // 0竞赛 1排名
		};
		console.log(data)
		this.jscallapp(data)
	},
	// 跳转微信
	openWeiXin() {
		let data = {
			action: "openweixin"
		};
		this.jscallapp(data);
	},
	// app 微信登录
	wxLogin() {
		let data = {
			action: "wxlogin"
		};
		this.jscallapp(data);
	},
	//开启用户权限
	overplaypemission() {
		var data = {
			action: "overplaypemission"
		};
		this.jscallapp(data)
	},
	jscallapp(data) {
		console.log(data)
		if (typeof WebViewJavascriptBridge != "undefined" && !!WebViewJavascriptBridge) {
			window.WebViewJavascriptBridge.callHandler(
				'callback', data,
				function(responseData) {}
			);
		}
	},
	//  判断当前是否是英文版
	isEn() {
		let local = store.state.lang;
		return local == 'en';
	},
	/**
	 * 浏览器及是否app环境判断
	 * result:["app","weixin","weibo","qq"]
	 */
	getCurrentAgent() {
		let result = "app"
		let ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
		if ((typeof window.WebViewJavascriptBridge) == 'object') {
			result = "app"
		} else {
			if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
				// alert("企业微信客户端");
				result = "businessWX"
			} else if (ua.match(/micromessenger/i) == 'micromessenger') {
				// alert("微信客户端");
				result = "weixin"
				wx.miniProgram.getEnv(function(res) {
					if (res.miniprogram) {
						// 小程序环境下逻辑
						result = "weixinxcx"
					}
				})
			}
		}
		return result
	},

	// 微信转发统计
	wxshareCallBack(type, link, rankId, userId) {
		// 转发数 回调 
		let formParams = new URLSearchParams();
		formParams.append('type', type); // 0竞赛 1排名
		formParams.append('url', link);
		http.putForm(`${common.baseUrl}/competition/${rankId}/sharer/${userId}/shareNum`, formParams).then({});
	},
	// 获取微信用户权限中的code
	validCode(name = "code") {
		let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		let r = window.location.search.substr(1).match(reg);
		if (r != null) {
			return unescape(r[2]);
		} else {
			return null;
		}
	},
	/**
	 * 向微信获取授权
	 */
	getPermission(fun) {
		let url;
		if (common.baseUrl == "https://t.witsbox.com/api") {
			url = `${common.baseUrl}/sale/wxAuthUrl`;
		} else {
			url = `${common.zsDomain}/shop/wxAuthUrlNew`;
		}
		http.get(url, {
			url: window.location.href
		}).then(res => {
			window.location.href = res;
		});
	},

	/** 
	 * @description 根据wxUnionId获取userId
	 * @param {fun} Fun
	 * @returns {wxUnionId} String
	 */
	getUserId(fun, wxUnionId) {
		if (!wxUnionId) {
			return
		}
		let url = `${common.baseUrl}/user/dailyUserId/${wxUnionId}`;
		http.get(url).then((res) => {
			if (res.success && res.dataModel) {
				// 绑定过
				fun('acceptorId', res.dataModel);
			} else {
				fun('acceptorWxOpenId', '');
			}
		})
	},
	getGMTTime() {
		let date = new Date().toString();
		let index = date.indexOf("GMT");
		let str = date.substring(index);
		return str
	},
	lessonLevelToString(level) {
		switch (level) {
			case 0, '零基础':
				return i18n.t("study.lessonLevel0");
				break;
			case 1, '初级':
				return i18n.t("study.lessonLevel1");
				break;
			case 2, '中级':
				return i18n.t("study.lessonLevel2");
				break;
			case 3, '高级':
				return i18n.t("study.lessonLevel3");
				break;
			case 4, '不限':
				return i18n.t("study.lessonLevel4");
				break;
			default:
				return level || "--";
		}
	},
	exitLogin() {
		localStorage.removeItem("microCuserId");
		localStorage.removeItem("oralTStduyD");
		localStorage.removeItem("studyThemeList");

		localStorage.removeItem("liveGoodsList");
		localStorage.removeItem("oralTSyncLevel");
		localStorage.removeItem("oralTUserInfoU");
		localStorage.removeItem("singleAdvertising4");
		localStorage.removeItem("singleAdvertising3");
		localStorage.removeItem("startingLesson");
		localStorage.removeItem("studentCourseList");
		localStorage.removeItem("studentCoachingList")
		localStorage.removeItem("personalNotice")
		localStorage.removeItem("RobotMssageList")
		localStorage.removeItem("examPublishing")
		localStorage.removeItem("sectionTypeGoodsList")
		localStorage.removeItem("studentPlacement")
		localStorage.removeItem("mobilePhoneUserInfo")
		localStorage.removeItem("publishSalonMap")
		localStorage.removeItem("commonToken");
		localStorage.removeItem("userInfo");
		localStorage.removeItem("userId");
		// 跳转至登录页强制刷新清空浏览器页面缓存，确保升级更新最新版页面资源（重要不可删除）
		window.location.href = common.loginPage
	},
	getQueryString(url, name) {
		var pattern = new RegExp("[?&]" + name + "\=([^&]+)", "g");
		var matcher = pattern.exec(url);
		var items = null;
		if (null != matcher) {
			try {
				items = decodeURIComponent(decodeURIComponent(matcher[1]));
			} catch (e) {
				try {
					items = decodeURIComponent(matcher[1]);
				} catch (e) {
					items = matcher[1];
				}
			}
		}
		return items;
	},
	// 生成token
	createCommonToken() {
		var str = "",
			range = 20,
			arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k',
				'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G',
				'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
			];
		for (var i = 0; i < range; i++) {
			let pos = Math.round(Math.random() * (arr.length - 1));
			str += arr[pos];
		}
		// let timestamp = (Date.parse(new Date()) + 86400000 * 61) * 7
		let timestamp = (Date.parse(new Date()) + 600000) * 7 // 10分钟
		let randomWord = str
		let token = randomWord + timestamp;
		localStorage.setItem("commonToken", token);

	},
	// Sun Jan 01 2012 00:00:00 GMT+0800 (中国标准时间) 转 yyyy/mm/dd hh:mm
	fstandardTime($data, format) {
		var year = $data.getFullYear()
		var month = ($data.getMonth() + 1 + '').padStart(2, '0')
		var date = ($data.getDate() + '').padStart(2, '0')
		var hour = ($data.getHours() + '').padStart(2, '0')
		var minute = ($data.getMinutes() + '').padStart(2, '0')
		var second = ($data.getSeconds() + '').padStart(2, '0')
		if (format == "yyyy-mm-dd") {
			return year + "-" + month + "-" + date;
		} else if (format == "hh:mm") {
			return hour + ":" + minute;
		} else if (format == 'yyyy.mm.dd') {
			return year + "." + month + "." + date;
		} else if (format == 'yyyy/mm/dd') {
			return year + "/" + month + "/" + date;
		} else if (format == 'yyyy/mm/dd hh:mm') {
			return year + "/" + month + "/" + date + " " + hour + ":" + minute;
		} else if (format == 'yyyy/mm/dd hh:mm:ss') {
			return year + "/" + month + "/" + date + " " + hour + ":" + minute + ":" + second;
		} else if (format == 'yyyy.mm.dd hh:mm') {
			return year + "." + month + "." + date + " " + hour + ":" + minute;
		} else if (format == 'yyyy') {
			return year;
		} else if (format == 'mm') {
			return month;
		} else if (format == 'yyyy-mm') {
			return year + "-" + month;
		} else if (format == 'mm-dd') {
			return month + '月' + date + '日'
		} else if (format == 'MM-DD') {
			return month + '-' + date
		} else if (format == "yyyymmdd") {
			return String(year) + String(month) + String(date);
		} else {
			return year + "-" + month + "-" + date + " " + hour + ":" + minute;
		}
	},
	// 2018-11-14 03:33:07 时间转换为时间戳（13位）
	formatTime(time) {
		if (!time) {
			return ''
		}
		let _time = time;
		_time = _time.replace(/-/g, '/');
		let result = new Date(_time);
		result = result.getTime();
		return result
	},

	/** 分辨率js判断
	 * @param {int} windowWidth 需要判断的宽度
	 */
	isRatio(windowWidth) {
		return window.innerWidth === windowWidth
	},
	/** 
	 * 时间戳格式化函数 
	 * @param  {int}    timestamp 要格式化的时间 
	 * @param  {string}           时间格式(yyyy-mm-dd, hh:mm 或者 yyyy-mm-dd hh:mm, yyyy.mm.dd, yyyy/mm/dd hh:mm, yyyy/mm/dd, yyyy, mm, yyyy-mm)
	 * @return {string}           格式化的时间字符串 
	 */
	formatTimeStamp(time, format) {
		time = new Date(time);
		var year = time.getFullYear();
		var month = time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : (time.getMonth() + 1);
		var date = time.getDate() < 10 ? "0" + time.getDate() : time.getDate();
		var hour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
		var minute = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();
		var second = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
		// var second = time.getSeconds();
		if (format == "yyyy-mm-dd") {
			return year + "-" + month + "-" + date;
		} else if (format == "hh:mm") {
			return hour + ":" + minute;
		} else if (format == 'yyyy.mm.dd') {
			return year + "." + month + "." + date;
		} else if (format == 'yyyy/mm/dd') {
			return year + "/" + month + "/" + date;
		} else if (format == 'yyyy/mm/dd hh:mm') {
			return year + "/" + month + "/" + date + " " + hour + ":" + minute;
		} else if (format == 'yyyy/mm/dd hh:mm:ss') {
			return year + "/" + month + "/" + date + " " + hour + ":" + minute + ":" + second;
		} else if (format == 'yyyy.mm.dd hh:mm') {
			return year + "." + month + "." + date + " " + hour + ":" + minute;
		} else if (format == 'yyyy') {
			return year;
		} else if (format == 'mm') {
			return month;
		} else if (format == 'yyyy-mm') {
			return year + "-" + month;
		} else if (format == 'mm-dd') {
			return month + '月' + date + '日'
		} else if (format == 'MM-DD') {
			return month + '-' + date
		} else if (format == "yyyymmdd") {
			return String(year) + String(month) + String(date);
		} else {
			return year + "-" + month + "-" + date + " " + hour + ":" + minute;
		}
	},
	/**
	 * 根据角色显示
	 * @param {Array} inputRoles 显示的角色id数组
	 * @returns {Boolean} true 显示 false 隐藏
	 */
	// 1:机构超管 2:运营管理 3:项目管理 4:教师管理 5:课程研发 6:教务 7:教师
	showByRoles(inputRoles) {
		if (!(inputRoles && inputRoles.length)) {
			return
		}
		let roles = localStorage.getItem('role') && JSON.parse(localStorage.getItem('role')) || []
		if (inputRoles.length) {
			// 是否有权限
			let flag = false
			for (let i = 0; i < inputRoles.length; i++) {
				if (roles.indexOf(inputRoles[i]) > -1) {
					flag = true
					break
				}
			}
			return flag
		}
	},
	// 微信config
	wxConfig(title, desc, link, imgUrl) {
		desc = (desc || "").replace(/<[^>]+>/g, "");
		link = link || window.location.href;
		imgUrl = imgUrl || common.shareCoverPath
		// console.log("wxConfig===", title, desc, link, imgUrl)

		let url;
		if (common.baseUrl == "https://t.witsbox.com/api") {
			url = `${common.baseUrl}/shop/wxConfig`;
		} else {
			url = `${common.zsDomain}/shop/wxConfigNew`;
		}
		// console.log("wxConfig===", common.zsDomain, url)
		if (this.getCurrentAgent() == "businessWX" || this.getCurrentAgent() == "weixin") {
			http.post(url, {
				url: window.location.href.split("#")[0]
			}).then(res => {
				if (res.success) {
					if (!(res && res.success)) {
						return false;
					}
					let dataModel = res.dataModel
					// 请求成功后保存
					let appId = dataModel.appId;
					let timeStamp = dataModel.timeStamp;
					let nonceStr = dataModel.nonceStr;
					let signature = dataModel.signature;
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。  
						appId: appId,
						timestamp: timeStamp,
						nonceStr: nonceStr,
						signature: signature,
						jsApiList: [
							'checkJsApi',
							'hideAllNonBaseMenuItem',
							'showMenuItems',
							'onMenuShareTimeline', //分享到朋友圈
							'onMenuShareAppMessage' //分享给朋友
						],
						openTagList: ['wx-open-launch-app']
					});
					let share_config = {
						title: title, //分享卡片标题
						desc: desc, //摘要,如果分享到朋友圈的话，不显示摘要。
						link: link, //分享链接
						imgUrl: imgUrl, //分享图，默认当相对路径处理，所以使用绝对路径的的话，“http://”协议前缀必须在。
						success: function() {
							// let instance = Toast('分享成功');
							// setTimeout(() => {
							// 	instance.close();
							// }, 1000);
							return true;
						},
						'cancel': function() {
							// 用户取消分享后执行的回调函数
							// let instance = Toast('您已取消分享');
							// setTimeout(() => {
							// 	instance.close();
							// }, 1000);
							return false;
						}
					}
					console.log("wxConfig===", share_config)
					wx.ready(function() {
						wx.hideAllNonBaseMenuItem();
						wx.showMenuItems({
							menuList: ["menuItem:share:appMessage", "menuItem:share:timeline"]
						});
						wx.updateAppMessageShareData(share_config);
						wx.updateTimelineShareData(share_config);
						wx.onMenuShareAppMessage(share_config);
						wx.onMenuShareTimeline(share_config);
						wx.checkJsApi({
							jsApiList: ['chooseImage', 'wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
							success: function(res) {
								console.log('微信分享可用')
							},
							fail: (err) => {
								console.log(err, '微信分享不可用')
							}
						})

					})
				}
			});
		}

	},
}


//////////////////
// WEBPACK FOOTER
// ./utils/global.js
// module id = null
// module chunks = 